import { useEffect, useState, useRef } from "react";
import { StyleSheet, css } from "aphrodite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { COLORS } from "~/config/themes";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
const Selector = (props) => {
  const {
    onOpen,
    onClose,
    value,
    items,
    label,
    showDropdown,
    dropdownStyle,
    selectorContainerStyles,
    selectorStyles,
    setSelected,
  } = props;
  const filterRef = useRef(null);
  const clearFilterRef = useRef(null);
  const toggleTimeout = useRef(null);

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    document.addEventListener("mousedown", onFilterClick);
    return () => {
      document.removeEventListener("mousedown", onFilterClick);
    };
  });

  useEffect(() => {
    setShowFilter(showDropdown);
  }, [showDropdown]);

  const onFilterClick = (e) => {
    if (clearFilterRef.current && clearFilterRef.current.contains(e.target)) {
      clearFilters(e);
      setShowFilter(false);
    } else {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        if (!showFilter) {
          setShowFilter(true);
          if (onOpen) {
            onOpen();
          }
        } else {
          clearTimeout(toggleTimeout.current);
          toggleTimeout.current = setTimeout(() => {
            setShowFilter(false);
          }, 100);
        }
      } else {
        setShowFilter(false);
        if (onClose) {
          onClose();
        }
      }
    }
  };

  const renderItems = () => {
    return items.map((item, index) => {
      return (
        <div
          className={css(styles.item)}
          key={`selector_${label}_${item.label}_${index}`}
          onClick={() => onItemSelect(item)}
        >
          {item.label}
        </div>
      );
    });
  };

  const onItemSelect = (item) => {
    setSelected(item);
    setShowFilter(false);
  };
  return (
    <div className={css(styles.selectorContainer, selectorContainerStyles)}>
      <span className={css(styles.selectorLabel)}>
        <label>{label}</label>
      </span>
      <div className={css(styles.filter, selectorStyles)} ref={filterRef}>
        <div className={css(styles.filterButtonText)}>{value.label}</div>
        {!showFilter ? (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={css(styles.filterIcon)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faChevronUp}
            className={css(styles.filterIcon)}
          />
        )}
        <div
          className={css(
            styles.dropdown,
            showFilter && styles.showDropdown,
            showFilter && dropdownStyle
          )}
        >
          {renderItems()}
        </div>
      </div>
    </div>
  );
};

const styles = StyleSheet.create({
  filter: {
    padding: "10px 20px",
    border: "1px solid",
    borderRadius: 8,
    border: `1px solid ${COLORS.BLACK(0.2)}`,
    cursor: "pointer",
    position: "relative",
    minWidth: 100,
    height: "100%",
    boxSizing: "border-box",
    lineHeight: "24px",
    background: "#fff",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    ":hover": {
      border: `1px solid ${COLORS.PRIMARY_ACTION()}`,
    },

    "@media only screen and (max-width: 767px)": {
      ":hover": {
        border: `1px solid ${COLORS.BLACK(0.2)}`,
      },
    },
  },
  filterIcon: {
    marginLeft: 16,
  },
  filterButtonText: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: 16,
  },
  dropdown: {
    position: "absolute",
    display: "none",
    width: 0,
    height: 0,
    background: "#fff",
    marginTop: 15,
    borderRadius: 4,
    // boxShadow: `4px 4px 2px 2px ${COLORS.BLACK(0.1)}`,
    boxShadow:
      "rgba(134, 144, 153, 0.18) 0px 4px 8px 0px, rgba(59, 65, 68, 0.05) 0px 1px 2px 0px",
    cursor: "initial",
    top: 30,
  },
  showDropdown: {
    display: "block",
    width: "100%",
    right: 0,
    height: "unset",
  },
  item: {
    width: "100%",
    textAlign: "center",
    fontSize: 16,
    padding: 10,
    borderBottom: `1px solid ${COLORS.BLACK(0.1)}`,
    cursor: "pointer",

    ":hover": {
      background: COLORS.PRIMARY_ACTION(),
      color: "#fff",
    },
  },
  selectorLabel: {
    fontSize: 12,
    fontWeight: 500,
    opacity: 0.7,
    textTransform: "uppercase",
    letterSpacing: ".01em",
    position: "absolute",
    top: -25,
    left: 0,
  },
  selectorContainer: {
    position: "relative",
  },
});

export default Selector;
